import { useState } from "react";

import Header from "../components/Header/Header";

const Support = () => {
    const [inputs, setInputs] = useState({
        name: '',
        whatsapp: '',
        unit: 'Clínica do esporte - Sul',
        requestType: 'Gesthor',
        description: '',
        anyDeskId: '',
        standardProcedures: 'Não',
        technician: '556232390124'
    });

    function handleSetInputValue(identifier, value) {
        setInputs((curInputs) => {
            return {
                ...curInputs,
                [identifier]: value
            };
        });
    }

    const handleSendWhatsAppMessage = (event) => {
        event.preventDefault();

        const message = `
            *Chamado Clínica do Esporte*\n\n` +
            `*Nome:* ${inputs.name}\n` +
            `*WhatsApp:* ${inputs.whatsapp}\n` +
            `*Unidade:* ${inputs.unit}\n` +
            `*Tipo de solicitação:* ${inputs.requestType}\n` +
            `*Descrição:* ${inputs.description}\n` +
            `*ID AnyDesk:* ${inputs.anyDeskId}\n` +
            `*Procedimentos padrões realizados:* ${inputs.standardProcedures}\n`;

        const url = `https://api.whatsapp.com/send?phone=${inputs.technician}&text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    }

    return (
        <>
            <Header />
            <div style={{ marginBottom: '2em' }}>
                <div className="container">
                    <h1 className="text-center text-primary">Chamados Clínica do Esporte</h1>
                    <form onSubmit={handleSendWhatsAppMessage}>
                        <div className="form-group">
                            <label>Nome <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.name} onChange={(e) => handleSetInputValue('name', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>WhatsApp <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.whatsapp} onChange={(e) => handleSetInputValue('whatsapp', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Selecione a unidade <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.unit} onChange={(e) => handleSetInputValue('unit', e.target.value)}>
                                <option value="Clínica do esporte - Sul">Clínica do esporte - Sul</option>
                                <option value="Clínica do esporte - Buriti">Clínica do esporte - Buriti</option>
                                <option value="Clínica do esporte - Planalto">Clínica do esporte - Planalto</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Qual sua solicitação <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.requestType} onChange={(e) => handleSetInputValue('requestType', e.target.value)}>
                                <option value="Gesthor">Gesthor</option>
                                <option value="WTT">WTT</option>
                                <option value="Computador (CPU)">Computador (CPU)</option>
                                <option value="Monitor">Monitor</option>
                                <option value="Estabilizador">Estabilizador</option>
                                <option value="Impressora">Impressora</option>
                                <option value="Perifericos (mouse, teclado, leitor, etc)">Perifericos (mouse, teclado, leitor, etc)</option>
                                <option value="Internet">Internet</option>
                                <option value="Outros">Outros</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Descreva sua solicitação (rica em detalhes) <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.description} onChange={(e) => handleSetInputValue('description', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Qual seu ID AnyDesk (Conectar ao PC) <span className="text-danger">*</span></label>
                            <input className="form-control" required value={inputs.anyDeskId} onChange={(e) => handleSetInputValue('anyDeskId', e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Realizou procedimentos padrões <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.standardProcedures} onChange={(e) => handleSetInputValue('standardProcedures', e.target.value)}>
                                <option value="Não">Não</option>
                                <option value="Sim">Sim</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Técnico <span className="text-danger">*</span></label>
                            <select className="form-control" required value={inputs.technician} onChange={(e) => handleSetInputValue('technician', e.target.value)}>
                                <option value="556232390124">André</option>
                                <option value="556232390125">Lucas</option>
                                <option value="556230914380">Mateus</option>
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary btn-block">
                            Enviar
                        </button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Support;